import React, { PureComponent } from 'react';
import Text from 'components/core/Text';
import Wrapper from './styles';

export default class extends PureComponent {
  render() {
    const { question, answer } = this.props;
    return (
      <Wrapper>
        <Text variant="textSmall" tag="h3" weight="bold" transform="uppercase" color="black">
          {question}
        </Text>
        <Text variant="textSmall" tag="div" color="gray" mt={1}>
          {answer}
        </Text>
      </Wrapper>
    );
  }
}
